// src/pages/ProjectsPage.tsx
// Projects page - placeholder for future implementation

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import ThemeToggle from '../components/ThemeToggle';
import { getRandomTagline } from '../utils/taglines';

const ProjectsPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  return (
    <div className="flex flex-col h-screen bg-background text-foreground overflow-hidden">
      {/* Header */}
      <header className="flex-shrink-0 border-b border-border bg-card/50 backdrop-blur-sm">
        <div className="flex items-center justify-between px-6 py-4">
          <div className="flex items-center space-x-4">
            <img
              src="/cubemate-logo.png"
              alt="Cubemate"
              className="w-10 h-10 rounded-lg"
            />
            <div>
              <div className="flex items-center space-x-2">
                <h1 className="text-xl font-bold bg-gradient-to-r from-primary to-brand bg-clip-text text-transparent">
                  Cubemate
                </h1>
              </div>
              <p className="text-xs text-muted-foreground/80 font-normal italic">
                {getRandomTagline()}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            {(user as any)?.subscription_tier !== 'ultimate' && (
              <button
                onClick={() => navigate('/settings?tab=subscription')}
                className="px-4 py-2 text-sm bg-gradient-to-r from-[#8E3BCE] to-[#6D2D8D] text-white hover:shadow-lg hover:shadow-primary/30 rounded-lg transition-all duration-200 font-semibold"
                title="Upgrade to premium"
              >
                Upgrade +
              </button>
            )}
            <button
              className="px-4 py-2 text-sm bg-white dark:bg-card text-foreground border border-border hover:bg-muted/50 rounded-lg transition-all duration-200 font-medium flex items-center space-x-2"
              title="Export"
            >
              <span>Export</span>
              <span>📤</span>
            </button>
            <ThemeToggle />
            <button
              className="w-9 h-9 text-foreground hover:bg-muted/50 rounded-lg transition-all duration-200 flex items-center justify-center"
              title="More options"
            >
              <span className="text-xl font-bold">⋯</span>
            </button>
          </div>
        </div>
      </header>

      {/* Body: Sidebar + Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Content Area */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="text-center max-w-2xl">
            <h1 className="text-4xl font-bold text-foreground mb-4">Project</h1>
            <p className="text-muted-foreground text-lg">
              This feature is coming soon. Stay tuned for updates!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;
